var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthoritiesSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.05001C11.3807 8.05001 12.5 6.93072 12.5 5.55001C12.5 4.1693 11.3807 3.05001 10 3.05001C8.6193 3.05001 7.50002 4.1693 7.50002 5.55001C7.50002 6.93072 8.6193 8.05001 10 8.05001Z",
    fill: "#5C5E69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.895431 0 0 0.895431 0 2V11C0 12.1046 0.895431 13 2 13H14C15.1046 13 16 12.1046 16 11V2C16 0.895431 15.1046 0 14 0H2ZM1 2C1 1.44772 1.44772 1 2 1H4V3H1V2ZM5 12V1H14C14.5523 1 15 1.44772 15 2V11C15 11.2852 14.8806 11.5425 14.6891 11.7247C14.1514 10.4939 12.8227 9 10 9C6.96283 9 5.65523 10.7296 5.20172 12H5ZM1 10H4V12H2C1.44772 12 1 11.5523 1 11V10ZM4 9H1V7H4V9ZM4 6H1V4H4V6Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthoritiesSvg);
export default __webpack_public_path__ + "static/media/authorities-svg.ce407a772cfec74f17a7791bbb74e17f.svg";
export { ForwardRef as ReactComponent };